import "core-js/modules/es.array.concat.js";
import http from '@/plugins/axios';
import store from '@/store';
var VERSION = 'v2';
export default {
  atualizar: function atualizar(identificador, payload) {
    var empresa = store.state.auth.empresa;
    return http.apiEmpresa.patch("".concat(empresa.url_instancia, "/").concat(VERSION, "/cliente/").concat(identificador, "/contato"), payload);
  },
  auth: function auth(payload) {
    return http.apiCore.post('/v1/cliente/auth', payload);
  },
  info: function info() {
    return http.apiCore.get('/v1/cliente/info');
  },
  cadastrarEmail: function cadastrarEmail(payload) {
    var empresa = store.state.auth.empresa;
    return http.apiEmpresa.post("".concat(empresa.url_instancia, "/").concat(VERSION, "/email/confirmar"), payload);
  },
  cadastrarWhatsapp: function cadastrarWhatsapp(payload) {
    var empresa = store.state.auth.empresa;
    return http.apiEmpresa.post("".concat(empresa.url_instancia, "/").concat(VERSION, "/whatsapp/confirmar"), payload);
  },
  cadastrarSms: function cadastrarSms(payload) {
    var empresa = store.state.auth.empresa;
    return http.apiEmpresa.post("".concat(empresa.url_instancia, "/").concat(VERSION, "/sms/confirmar"), payload);
  },
  cadastrarLigacao: function cadastrarLigacao(payload) {
    var empresa = store.state.auth.empresa;
    return http.apiEmpresa.post("".concat(empresa.url_instancia, "/").concat(VERSION, "/ligacao/confirmar"), payload);
  }
};